var render = function () {
  var _ref, _ref2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container,
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.limited ? [_c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 5,
      expression: "5"
    }],
    class: _vm.$style.section
  }, [_c('span', {
    directives: [{
      name: "m-r",
      rawName: "v-m-r",
      value: 5,
      expression: "5"
    }],
    class: _vm.$style.label,
    domProps: {
      "textContent": _vm._s(_vm.$t('card.item.month.payouts'))
    }
  }), _c('span', {
    class: [_vm.$style.value, (_ref = {}, _ref[_vm.$style.empty] = _vm.isEmptyPayoutCount, _ref)],
    domProps: {
      "textContent": _vm._s(_vm.displayPayoutCounts)
    }
  })])] : _vm._e(), _c('payout-progress-bar', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 5,
      expression: "5"
    }],
    attrs: {
      "loading": _vm.loading,
      "payout-sums": _vm.payoutSums,
      "is-filled": _vm.isFilledProgress
    }
  }), _c('div', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }, {
      name: "justify",
      rawName: "v-justify",
      value: {
        content: 'space-between'
      },
      expression: "{ content: 'space-between' }"
    }],
    class: _vm.$style.section
  }, [_c('div', {
    class: _vm.$style.leftSide
  }, [_c('span', {
    class: _vm.$style.label,
    domProps: {
      "textContent": _vm._s(_vm.$t('card.item.paid'))
    }
  }), _c('span', {
    class: _vm.$style.value,
    domProps: {
      "textContent": _vm._s(_vm.displayActualAmount)
    }
  })]), _c('div', {
    class: _vm.$style.rightSide
  }, [_c('span', {
    class: _vm.$style.label,
    domProps: {
      "textContent": _vm._s(_vm.$t('card.item.more.possible'))
    }
  }), _c('span', {
    class: [_vm.$style.value, (_ref2 = {}, _ref2[_vm.$style.empty] = _vm.isEmptyPayoutAmount, _ref2)],
    domProps: {
      "textContent": _vm._s(_vm.displayAvailableAmount)
    }
  })])]), _vm.limits.limitsExceeded && _vm.isNotifying ? _c('div', {
    class: _vm.$style.notice
  }, [_c('div', {
    class: _vm.$style.text,
    domProps: {
      "textContent": _vm._s(_vm.$t('card.item.next.payout.availability'))
    }
  }), _c('div', {
    class: _vm.$style.date,
    domProps: {
      "textContent": _vm._s(_vm.displayDate)
    }
  })]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }